import axios from 'axios'
import url from '../url.js'

function listAddress () {
  return fetch(url.customerAddresses, null)
}
function addAddress (data) {
  return fetch(url.customerAddAddress, data)
}
function editAddress (data) {
  return fetch(url.customerEditAddress, data)
}
function removeAddress (data) {
  return fetch(url.customerRemoveAddress, data)
}
function getCustomerInfo () {
  return fetch(url.customerGetInfo, null)
}
function editCustomerInfo (data) {
  return fetch(url.customerEditInfo, data)
}
function editCustomerPassword (data) {
  return fetch(url.customerEditPassword, data)
}
function customerCredit (data) {
  return fetch(url.customerCredit, data)
}
function customerPointsPaging (data) {
  return fetch(url.customerPointsPaging, data)
}
function fetch (urlString, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json'
    })
      .then(response => {
        resolve(response)
      })
  })
}

export default {
  getAddressList () {
    return listAddress()
  },
  addAddress (data) {
    return addAddress(data)
  },
  editAddress (data) {
    return editAddress(data)
  },
  removeAddress (data) {
    return removeAddress(data)
  },
  getCustomerInfo () {
    return getCustomerInfo()
  },
  editCustomerInfo (data) {
    return editCustomerInfo(data)
  },
  editCustomerPassword (data) {
    return editCustomerPassword(data)
  },
  customerCredit (data) {
    return customerCredit(data)
  },
  customerPointsPaging (data) {
    return customerPointsPaging(data)
  }
}



// WEBPACK FOOTER //
// ./src/api/profile/customer.js